export default {"src":"/_next/static/media/chips.a54a3a94.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};